<div class="modal-dialog">
  <datalean-modal-header [title]="title" [dialogId]="dialogId" [buttons]="headerButtons"></datalean-modal-header>
  <div class="modal-content">
    <div modalTarget></div>
  </div>
</div>
